import { useState } from "react";
import { Outlet } from "react-router-dom";

export default function DashboardParent(){
const [ itemObj , setItemObj] = useState({}); //設定當前點了table哪一筆tr物件(CRUD)
const [ action , setAction ] = useState(''); //設定當前是做哪個動作(CRUD)
const [ currentStatus,setCurrentStatus ] = useState({}); //設定當前是點了返回鍵還是確定按鈕返回是否要重抓查詢畫面資料
          
  



  return (
    <Outlet context={{itemObj,setItemObj,action,setAction,currentStatus,setCurrentStatus}} />
  );
}